export default __webpack_public_path__ + "static/media/GiftBox3.2c52fc75.jpg";